import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { CompetitorTypes } from "~enums/competitorTypes";
import { useApi } from "~hooks/apiHooks/useApi";
import { useSportConfiguration } from "~hooks/useSportConfiguration";
import type { UpsertPlacingModel } from "~pages/FinalStandings/types/upsertPlacingModel";
import type { Placing } from "~types/placing";
import type { PlacingEntityResponse } from "~types/placingEntity";
import type { PlacingPersonResponse } from "~types/placingPerson";

export const useUpdatePlacing = () => {
  const { sport, organizationId, seasonId } = useParams();
  const request = useApi();
  const queryClient = useQueryClient();
  const { competitorType } = useSportConfiguration();

  const entrantUrlPart = competitorType === CompetitorTypes.Person ? "persons" : "entities";

  return useMutation<PlacingEntityResponse | PlacingPersonResponse, Error, UpsertPlacingModel>({
    mutationFn: async (upsertModel: UpsertPlacingModel) => {
      const url = `${sport}/o/${organizationId}/seasons/${entrantUrlPart}/placings/${upsertModel.placingId}`;
      return await request(url, { method: "PUT", body: upsertModel.upsertData });
    },
    onSuccess: async (response: { data: Array<Placing> }) => {
      if (response?.data && response.data.length > 0) {
        await queryClient.invalidateQueries({
          queryKey: ["final-standings", sport, organizationId, seasonId],
        });
      }
    },
  });
};
